import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  loading: true,
  scoringHistory: {
    average: 0,
    dateBeginWeek: '-',
    dateEndWeek: '-',
    weekPoints: {
      m: 0,
      tu: 0,
      w: 0,
      th: 0,
      f: 0,
      sa: 0,
      su: 0,
    },
  },
});

const reducer = function scoringHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_SCORING_HISTORY:
      return state.set('scoringHistory', action.scoringHistoryData);
    case t.SET_LOADING_SCORING_HISTORY:
      return state.set('loading', action.value);
    default:
      return state;
  }
};

export default reducer;
